import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorService } from 'src/app/services/error.service';
import { StudentService } from 'src/app/services/student.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string = '';
  password: string = '';
  rol: number = 1;
  loading: boolean = false;

  constructor(
    private toastr: ToastrService,
    private _userService: UserService,
    private _studentService: StudentService,
    private router: Router,
    private _errorService: ErrorService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {}

  login() {
    if (this.username === '' || this.password === '') {
      this.toastr.error('Todos los campos son obligatorios', 'Error');
      return;
    }

    const user: User = {
      username: this.username,
      password: this.password,
      rol: this.rol
    };

    this.loading = true;
    this._userService.login(user).subscribe({
      next: (token) => {
        localStorage.setItem('token', token);
        this.authService.setLoggedIn(true);
        this.loadAuthenticatedUser();
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
        this._errorService.msjError(e);
      }
    });
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.login();
    }
  }

  private loadAuthenticatedUser() {
    this._userService.getUserByEmail(this.username).subscribe({
      next: (userData: User | null) => {
        if (!userData?.id) {
          this.failAuthentication('No se pudo resolver el usuario autenticado');
          return;
        }

        if (Number(userData.status || 0) !== 1) {
          this.loading = false;
          this.failAuthentication('Su usuario no se encuentra habilitado para ingresar');
          return;
        }

        this.authService.setUserData(
          userData.username,
          userData.id,
          userData.status || 0,
          userData.rol || 0
        );

        if (userData.rol === 2) {
          this.loadStudentSession(userData.id);
          return;
        }

        this.loading = false;
        this.router.navigate(['/student']);
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
        this.failAuthentication();
        this._errorService.msjError(e);
      }
    });
  }

  private loadStudentSession(userId: number) {
    this._studentService.getStudentByUserId(String(userId)).subscribe({
      next: (studentData) => {
        if (!studentData?.id || !studentData.userid) {
          this.failAuthentication('No se pudo vincular el estudiante autenticado');
          return;
        }

        if (Number(studentData.status || 0) !== 1) {
          this.loading = false;
          this.failAuthentication('El estudiante no se encuentra habilitado para tomar practicas');
          return;
        }

        this.authService.setStudentData({
          idstudent: studentData.id,
          userid: studentData.userid,
          name: studentData.name,
          lastname: studentData.lastname,
          ci: studentData.ci,
          status: studentData.status
        });

        this.loading = false;
        this.router.navigate(['/practiceinscription']);
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
        this.failAuthentication();
        this._errorService.msjError(e);
      }
    });
  }

  private failAuthentication(message?: string) {
    this.authService.clearSession();
    if (message) {
      this.toastr.error(message, 'Error');
    }
  }
}
